module.exports = __webpack_public_path__ + "img/share.4e76082a.png";